import axios from "axios";
import {
  fetchInspirationDataFromCms,
  fetchStoriesDataFromCms,
  getCatgoryDataFromCms,
  getCountsFromCms,
  getIndividualAuthorFromCms,
} from "./impactCmsService";

const LEGACY_API = "https://api.iamironlady.com/api";

const tryLegacyApi = async (request, transform = (response) => response.data) => {
  try {
    const response = await request();
    if (response?.status === 200) {
      return transform(response);
    }
  } catch (error) {
    console.warn("Legacy impact API unavailable, using CMS fallback.", error?.message);
  }

  return null;
};

export const fetchStoriesData = async (pageNumber) => {
  const legacyData = await tryLegacyApi(() =>
    axios.get(`${LEGACY_API}/success-stories?page=${pageNumber}`)
  );

  if (legacyData) {
    return legacyData;
  }

  return fetchStoriesDataFromCms(pageNumber);
};

export const fetchInspirationData = async (pageNumber) => {
  const legacyData = await tryLegacyApi(
    () => axios.get(`${LEGACY_API}/success-stories-inspiration?page=${pageNumber}`),
    (response) => response.data.data
  );

  if (legacyData) {
    return legacyData;
  }

  return fetchInspirationDataFromCms(pageNumber);
};

export const getCatgoryData = async (params) => {
  const legacyData = await tryLegacyApi(
    () => axios.get(`${LEGACY_API}/success-story-by-filter`, { params }),
    (response) => response.data.data
  );

  if (legacyData) {
    return legacyData;
  }

  return getCatgoryDataFromCms(params);
};

export const getCounts = async () => {
  const legacyData = await tryLegacyApi(
    () => axios.get(`${LEGACY_API}/get-all-success-stories-summary-details`),
    (response) => response.data.data
  );

  if (legacyData) {
    return legacyData;
  }

  return getCountsFromCms();
};

export const getIndividualAuthor = async (storyId) => {
  const legacyData = await tryLegacyApi(
    () => axios.get(`${LEGACY_API}/success-story-by-id?storyId=${storyId}`),
    (response) => response.data.data
  );

  if (legacyData) {
    return legacyData;
  }

  return getIndividualAuthorFromCms(storyId);
};
